import { IsString } from 'class-validator';

export class ValidateSweetFaceNewTerminalRequestDto {
  @IsString()
  // @ApiProperty({ description: 'Bank Merchant ID' })
  mid: string;

  @IsString()
  // @ApiProperty({ description: 'Bank Terminal ID' })
  tid: string;
}
